import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleClaimMappingModel } from 'src/app/components/security/roles/models/roleClaimMapping';
import { RoleModel } from 'src/app/components/security/roles/models/roleModel';
import { ClaimModel } from 'src/app/components/security/claims/models/claimModel';
import { environment } from 'src/environments/environment';
import { RestAPIService } from 'src/app/services/restapi.service';
import { ToastService } from 'src/app/services/toaster.service';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'app-roleclaim',
    templateUrl: './manageroleclaim.component.html'
})
export class RoleClaimComponent implements OnInit {
    roleId!: string;
    roleClaimList: RoleClaimMappingModel[] = [];
    claimList: ClaimModel[] = [];
    role: RoleModel = new RoleModel();

    displayedColumns = ['isChecked', 'code', 'description'];
    
    constructor(
        public _restAPI: RestAPIService,
        private route: ActivatedRoute, private toast: ToastService, 
        private router: Router) {
            this._restAPI.loading  = false;
            localStorage["applyRoleFilterValue"] = 'true';
        }

        //#region Get query params
        getQueryParams(): void {
            this.route
                .queryParams
                .subscribe(params => {
                    // Defaults to 0 if no query param provided.
                    let id = params['roleId'] as string;
                    this.roleId = id || '00000000-0000-0000-0000-000000000000';
                    if (this.roleId == '00000000-0000-0000-0000-000000000000') {
                        this.router.navigateByUrl('/security/role');
                    }
                });
        }
        //#endregion
  
    async ngOnInit() {
        this.getQueryParams();
        this._restAPI.loading  = true;
        const roleAPI = this._restAPI.get<RoleModel>(environment.apiURL + 'api/role/' + this.roleId);
        const roleClaimAPI = this._restAPI.get<RoleClaimMappingModel[]>(environment.apiURL + 'api/roleclaim/' + this.roleId);
        const claimAPI = this._restAPI.get<ClaimModel[]>(environment.apiURL + 'api/claim/list');

        forkJoin({ role: roleAPI, roleClaimList: roleClaimAPI, claimList: claimAPI }).subscribe({
            next: result => {
                this._restAPI.loading  = false;
                this.role = result.role;
                this.roleClaimList = result.roleClaimList;
                this.claimList = result.claimList;
                for (const [index, claim] of this.claimList.entries()) {
                    const item = this.roleClaimList.find(y => y.claimId == claim.id);
                    this.claimList[index].isChecked = (item?.id?.length ?? 0) > 0;
                }
            },
            error: err => {
                this._restAPI.loading  = false;
                this.toast.error(err);
            }
        });
    } 

    async saveRoleClaim() {
        if (this.role.id != null && this.role.id.length > 0) {
            let postData = [];

            for (const claim of this.claimList) {
                if (claim.isChecked) {
                    postData.push({
                        id: '00000000-0000-0000-0000-000000000000',
                        roleId: this.role.id,
                        claimId: claim.id
                    });
                }
            }
            this._restAPI.loading  = true;
            this._restAPI.put<string>(environment.apiURL + 'api/roleclaim/editbyrole/' + this.role.id, postData).subscribe({
                next: (results) => {
                    this._restAPI.loading  = false;
                    this.toast.show("Claims have been updated successfully");
                    this.router.navigateByUrl('/roles');
                },
                error: (error) => {this._restAPI.loading  = false;console.error(error)}
            });
        }
    }
}